import React, { useEffect, useMemo } from "react";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import totalDriverIcon from "packages/novous_web/src/assets/icons/totalDriver.svg";
import activeDriverIcon from "packages/novous_web/src/assets/icons/activeDriver.svg";
import availableDriverIcon from "packages/novous_web/src/assets/icons/availableDriver.svg";
import highAlert from "packages/novous_web/src/assets/icons/highAlert.svg";
import infoIcon from "packages/novous_web/src/assets/icons/i.svg";
import { API_ENDPOINTS } from "packages/novous_web/src/api/endpoints";
import useAxios from "packages/novous_web/src/api/useAxios";
import { IconButton } from "@mui/material";
import { useAuth } from "packages/novous_web/src/authContext/useAuth";

type ColumnObjType = {
    [key: string]: {
        name: string;
        status: boolean;
    };
};


const DriverCoachingTiles = () => {
    let driverTilesData = [
        {
            icon: totalDriverIcon,
            heading: "Under Coaching",
            value: "0",
        },
        {
            icon: activeDriverIcon,
            heading: "Coaching Required",
            value: "0",
        },
        {
            icon: availableDriverIcon,
            heading: "Coaching Completed",
            value: "0",
        },
        {
            icon: highAlert,
            heading: "Avg Alerts Per Driver",
            value: "0",
        },
    ];

    const { user } = useAuth();
    const { data: driverData, error: driverError, loading: driverLoading, fetchData: fetchDriverData } = useAxios<any>(
        `${API_ENDPOINTS.alarm.GET_DRIVERS_ALERT_COUNT}`,
        "POST"
    );

    useEffect(() => {
        if (user?.customer_id) {
            fetchDriverData({ fleetId: user?.customer_id });
        }
    }, [user]);

    driverTilesData[0].value = driverData?.data.totalDrivers || 0;
    driverTilesData[1].value = driverData?.data.activeDrivers || 0;
    driverTilesData[2].value = driverData?.data.availableDrivers || 0;
    driverTilesData[3].value = driverData?.data.highAlertDrivers || 0;
    // const filteredTileData = useMemo(() => {
    //     return driverTilesData.filter((item, index) => {

    //         const stateName = 'Stat' + (index + 1);
    //         if (data) {
    //             if (data[stateName].name === item.heading) {
    //                 return data[stateName].status;
    //             }
    //             return false;
    //         } else {
    //             return true;
    //         }
    //     });
    // }, [data, driverTilesData]);
    return (
        <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {driverTilesData.map((tile, index) => (
                <Paper
                    key={index}
                    sx={{ borderRadius: "12px" }}
                    className="border border-[#f0eff8] p-4 flex flex-col gap-1 items-start"
                >
                    <div className="flex items-center gap-2 w-full">
                        <IconButton sx={(theme) => ({
                            background: theme.palette.selected,
                            padding: '4px'
                        })}>
                            <img src={tile.icon} alt="icon" color="primary" />
                        </IconButton>
                        <div className="flex flex-1 min-w-0 flex-col justify-start gap-1">
                            <Typography
                                variant="button"
                                fontWeight={400}
                                noWrap
                                sx={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    maxWidth: "100%"
                                }}
                            >
                                {tile.heading}
                            </Typography>
                        </div>

                        <img
                            src={infoIcon}
                            alt="info icon"
                            title="More info"
                            className="w-4 h-4 cursor-pointer"
                        />
                    </div>
                    <div className="flex items-center w-full gap-2 flex-nowrap">
                        <div className="invisible w-6 h-6">
                            {tile.icon}
                        </div>
                        <Typography
                            variant="h6"
                            fontWeight={600}
                            className="flex-grow px-2 w-full whitespace-nowrap overflow-hidden text-ellipsis"
                        >
                            {tile.value}
                        </Typography>
                    </div>
                </Paper>
            ))}
        </div>
    );
};

export default DriverCoachingTiles;
